import React from "react";
import i18n from "i18next";

import ArticleItem from "@/react-components/ArticleItem";
import { api } from "@/utils/api";
import url from "@/utils/url";
import { reportTypeEnum } from "@/utils/enum";
import LoadMore from "@/react-components/LoadMore";
import NewsHeader from "@/react-components/NewsHeader";

class RelatedArticle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.rendering?.itemId !== this.props?.rendering?.itemId) {
      this.fetchData();
    }
  }

  fetchData = () => {
    const { reportType } = this.props;
    if (reportType === reportTypeEnum.research) {
      this.fetchResearchData();
    } else {
      this.fetchLibraryData();
    }
  };

  fetchResearchData = () => {
    const itemId = this.props?.rendering?.itemId;
    api.report
      .related({
        pageIndex: 1,
        pageSize: 4,
        itemId,
      })
      .then((res) => {
        this.setState({
          articles: res.list,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchLibraryData = () => {
    const itemId = this.props?.rendering?.itemId;
    api.library
      .related({
        pageindex: 1,
        pagesize: 4,
        itemId,
      })
      .then((res) => {
        this.setState({
          articles: res.list,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  render() {
    const { articles } = this.state;
    const { reportType } = this.props;
    const to = {
      pathname:
        reportType === reportTypeEnum.research
          ? url.researchRelated
          : url.libraryCaseStudy,
      state: { itemId: this.props?.rendering?.itemId, reportType },
    };

    return (
      <React.Fragment>
        <NewsHeader
          title={i18n.t("TCMS01011_related")}
          showSubTitle={false}
          to={to}
          showMore={articles && articles.length > 0}
        />

        {articles && articles.length > 0 ? (
          <section>
            <div className="news-section-content">
              {articles.map((item, index) => (
                <ArticleItem key={index} articles={item} />
              ))}
            </div>
            <LoadMore to={to} />
          </section>
        ) : (
          <div className="article-empty-result">
            {i18n.t("TCMS01011_emptyResult")}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default RelatedArticle;
